<table *ngFor="let weight of weights" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="weight.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ weight.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="weight.WeightValue && weight.Units && weight.Units >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationweight.weight' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ weight.WeightValue }} {{ weight.Units | weightunits }}</span>
      </p>
    </td>
  </tr>
</table>
